<template>
    <div class="flex flex-wrap items-end gap-3">
        <div class="flex flex-col">
            <label
                class="text-xs font-medium uppercase tracking-wide text-gray-400"
                :for="`${inputIdPrefix}-from`"
            >
                {{ t("vue.kiosk_activity_logs_from") }}
            </label>
            <input
                :id="`${inputIdPrefix}-from`"
                v-model="localFrom"
                type="date"
                class="mt-1 rounded-lg border-0 px-3 py-1.5 text-sm text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600"
                @change="applyRange"
            />
        </div>

        <div class="flex flex-col">
            <label
                class="text-xs font-medium uppercase tracking-wide text-gray-400"
                :for="`${inputIdPrefix}-to`"
            >
                {{ t("vue.kiosk_activity_logs_to") }}
            </label>
            <input
                :id="`${inputIdPrefix}-to`"
                v-model="localTo"
                type="date"
                class="mt-1 rounded-lg border-0 px-3 py-1.5 text-sm text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600"
                @change="applyRange"
            />
        </div>

        <button
            type="button"
            class="rounded-lg bg-white px-3 py-1.5 text-sm font-medium text-gray-700 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
            @click="applyDefaultRange"
        >
            {{ t("vue.kiosk_activity_logs_last_week") }}
        </button>
    </div>
</template>

<script lang="ts" setup>
import { ref, watch } from "vue";
import { useTranslations } from "@/composables/useTranslations";

const props = withDefaults(
    defineProps<{
        from: string;
        to: string;
        inputIdPrefix?: string;
    }>(),
    {
        inputIdPrefix: "kiosk-range",
    },
);

const emit = defineEmits<{
    (event: "change", range: { from: string; to: string } | null): void;
}>();

const { t } = useTranslations();

const localFrom = ref<string>(props.from);
const localTo = ref<string>(props.to);

watch(
    () => [props.from, props.to],
    ([from, to]: string[]): void => {
        localFrom.value = from;
        localTo.value = to;
    },
);

const applyRange = (): void => {
    if (localFrom.value === "" || localTo.value === "") {
        return;
    }

    if (localFrom.value > localTo.value) {
        return;
    }

    emit("change", { from: localFrom.value, to: localTo.value });
};

const applyDefaultRange = (): void => {
    emit("change", null);
};
</script>
